<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Utilisateurs actifs</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <h4>{{ activeUsers }} utilisateur<span v-if="activeUsers > 1">s</span> actif<span v-if="activeUsers > 1">s</span></h4>
          <v-client-table class="mt-4" :columns="columns" :data="items" :options="options">
            <div slot="profil" slot-scope="props">
              {{ props.row.profil_active.length >0 ? props.row.profil_active[0].libelle : 'n.d' }}
            </div>
            <div slot="last_seen" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ getFormattedDateTime(props.row.last_seen) }}</span>
            </div>
          </v-client-table>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import moment from 'moment';
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "Cron",
    data() {
      return {
        activeUsers: 0,
        dataIsReady: false,
        items: [],
        columns: ['nom', 'prenom', 'profil', 'last_seen'],
        options: {
          headings: {
            nom: 'Nom',
            prenom: 'Prénom',
            profil: 'Profil',
            last_seen: 'Dernière activité',
          },
          perPage: 50,
          filterable: false,
          sortable: ['nom', 'prenom', 'last_seen'],
          perPageValues: [50,100],
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/administration/active-users")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.users;
            this.dataIsReady = true;
            this.activeUsers = this.items.length;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
    }
  }
</script>
